import { gql } from '@apollo/client'

/**
 * First-paint TileV2 content. Keep row-wide requests limited to fields needed
 * to render and route a tile; expensive personalized/detail metadata loads only
 * at the interaction that needs it.
 */
const GET_TILE_CONTENT = gql`
  query GetTileContent(
    $titleGroupIds: [String]!
    $language: [String]!
    $imageType: [String]!
    $includeSeriesImage: Boolean!
  ) {
    contentList(
      where: { titleGroupId: { in: $titleGroupIds } }
      language: $language
    ) {
      content {
        id
        title
        path
        episodeNumber
        seasonNumber
        contentType
        contentId
        titleGroupId
        primaryLanguage
        languageFullText
        shortDescription
        ctaLabel
        ctaPath
        featureMedia {
          duration
          mediaId
          contentPolicy {
            accessCheck {
              allowed
              countryAllowed
              subscriptionsAllowed
              isFreeAllowed
            }
          }
          userMediaPosition {
            position
          }
        }
        imageContentRelationships(language: $language, types: $imageType) {
          type
          image {
            url
          }
        }
        contentSeries(language: $language) {
          contentId
          title
          path
          imageContentRelationships(
            language: $language
            types: $imageType
          ) @include(if: $includeSeriesImage) {
            type
            image {
              url
            }
          }
        }
      }
    }
  }
`

export default GET_TILE_CONTENT
